import { useSelector } from "react-redux";
import { Layout, Row, Col } from "antd";
import { Title } from "../../Utils/UI/Text";
import { getCarbonFluxSelector } from "../Infrastructure/CarbonFlux.reducer";
import CarbonFluxBoard from "./CarbonFluxBoard";

const { Content } = Layout;

export default function CarbonFlux() {
  const carbonFluxData = useSelector(getCarbonFluxSelector);

  return (
    <Content>
      <Title children=" Net Removal (Carbon Flux)" />

      <Row>
        <Col span={24}>
          <CarbonFluxBoard data={carbonFluxData} />
        </Col>
      </Row>
    </Content>
  );
}
